import { Col, Modal, Row } from 'antd';
import React, { useEffect } from 'react';
import { DateTime } from 'luxon';

import PaymentTypes from '../payment-types';
import { ButtonType, TAButton } from '../../widgets';
import { useTheme } from 'styled-components';

const PaymentConfirmationModal = ({ onSubmit, onCancel, visible, paymentInfo, onOffline, loading }: any) => {
	let interviewPackage = paymentInfo.type === PaymentTypes.INTERVIEWS_PACKAGE;
	const theme = useTheme();
	return (
		<Modal footer={null} visible={visible} onCancel={onCancel}>
			<div className="w-100">
				<Row className="mb-3">
					<h2 style={{ fontSize: '1.5rem' }}>
						{interviewPackage ? 'Confirm Payment' : 'Hiring Successfully done'}
					</h2>
				</Row>
				<Row className="mb-5 ">
					<Col xs={24} lg={{ span: 15 }}>
						<div
							className="d-flex mb-2 align-items-center"
							style={{
								backgroundColor: '#08CC94',
								borderRadius: '5px',
								padding: '10px',
								width: '100%',
								height: '84px'
							}}
						>
							<div className="d-flex flex-column align-items-left me-4">
								<span style={{ color: '#fff', fontWeight: 500 }}>Type</span>
								{interviewPackage ? (
									<span style={{ color: '#fff', fontWeight: 500 }}>Package</span>
								) : null}
								{paymentInfo.issueDate && (
									<span style={{ color: '#fff', fontWeight: 500 }}>Issuing Date</span>
								)}
							</div>
							<div className="d-flex flex-column">
								<span style={{ color: '#fff' }}>{paymentInfo.type}</span>
								{interviewPackage ? <span style={{ color: '#fff' }}>{paymentInfo.title}</span> : null}
								{paymentInfo.issueDate && (
									<span style={{ color: '#fff' }}>
										{DateTime.fromJSDate(paymentInfo.issueDate).toLocaleString(DateTime.DATE_MED)}
									</span>
								)}
							</div>
						</div>
					</Col>

					<Col xs={24} lg={{ span: 7, push: 2 }}>
						<div
							style={{
								backgroundColor: '#08CC94',
								borderRadius: '5px',
								padding: '10px',
								height: '84px',
								width: '100%'
							}}
						>
							<p style={{ color: '#fff' }}>Total</p>
							<h3 style={{ color: '#fff', fontSize: '1.6rem' }}>USD {paymentInfo.total}</h3>
						</div>
					</Col>
				</Row>
				<Row className="d-flex justify-content-center mb-4">
					<TAButton btntype={ButtonType.PRIMARY} className="me-2" onClick={onSubmit} loading={loading}>
						Submit
					</TAButton>
					<TAButton onClick={onCancel} btntype={ButtonType.SECONDARY}>
						Cancel
					</TAButton>
				</Row>
				<Row className="d-flex justify-content-center">
					<span
						className="me-4"
						onClick={() => {
							onCancel && onCancel();
							onOffline && onOffline();
						}}
						style={{ color: theme.TA_GREEN, cursor: 'pointer', textDecoration: 'underline' }}
					>
						{' '}
						Offline Payment
					</span>
				</Row>
			</div>
		</Modal>
	);
};

export default PaymentConfirmationModal;
